module.exports = __webpack_public_path__ + "static/media/13.245a1d55.jpg";